module.exports = __webpack_public_path__ + "img/hydro-cortisone.31261a19.png";